import React  from 'react';
import { useNavigate } from 'react-router-dom' ;
import { IconButton } from '@mui/material'
import { Box } from '@mui/system'
import { useRecoilValue_TRANSITION_SUPPORT_UNSTABLE } from 'recoil'
import ManageStorage from 'src/shared/global/manageStorage';
import { historyRouteState } from 'src/store/global/historyState'
import queryString from 'query-string';

const OptionsUserGuest = () => {
    const historyRoute = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(historyRouteState);
    const currentUrl = ManageStorage.getValueFromStorage("currentUrl");
    const query = queryString.parse(window.location.search)

    const totem = ManageStorage.getValueFromStorage("TOTEM");

    const navigate = useNavigate();

    const handleAccessLogin = (event) => {
        //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`);
        navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`);
    }

    const handleSearchHour = (event) => {
        //historyRoute.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}`);
        navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}`);
    }

    return (
        <>
            <Box sx={{ flexGrow: 1, width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                {
                    currentUrl && currentUrl.includes("/login") ?
                        <IconButton disableRipple onClick={handleSearchHour} sx={{ p: 0, mr: 2, fontSize: 14, fontWeight: 600, color: 'white',  fontFamily: 'Montserrat', }}>
                            Buscar hora
                        </IconButton> :

                    totem && totem === "OK" ? <></> :<IconButton disableRipple onClick={handleAccessLogin} sx={{ p: 0, mr: 2, fontSize: 14, fontWeight: 600, color: 'white',  fontFamily: 'Montserrat', }}>
                            Iniciar sesión
                        </IconButton>
                }
            </Box>
        </>
    )
}

export default OptionsUserGuest
